export const EULA_NUR = `
<div class="row">
    <div class="col-12 text-center">
        <h3>AI-GENERATED CONTENT LICENSE</h3>
    </div>
</div>

<h6>1. Definitions</h6>
<ul>
    <li>“AI-Generated Content” or “AI Image” means any visual content generated using IndiaPicture’s artificial intelligence tools.</li>
    <li>“Unreviewed AI Image” means an AI output downloaded immediately after creation, without undergoing compliance review. These images are licensed only for internal evaluation.</li>
    <li>“Reviewed / Approved AI Image” means an AI image that has been submitted by the User, manually reviewed by IndiaPicture’s compliance team, approved for commercial use, and issued with a formal Commercial AI License Certificate.</li>
    <li>“Synthetic Human” means an AI-generated human image that represents a fictional person but may unintentionally resemble a real individual.</li>
    <li>“User Input” means prompts, text, uploads, reference material, or any data provided by the User to generate AI outputs.</li>
    <li>“Commercial Use” means any public-facing, distributed, promotional, client-facing, published, or monetized use, including advertising, marketing, packaging, print, OOH, broadcast, editorial, social media, apps, or websites.</li>
</ul>

<h6>2. License Framework for AI-Generated Content</h6>

<h6>2.1. Unreviewed AI Images — Internal Evaluation Only</h6>
<ul>
    <li>Unreviewed AI Images may only be used for internal drafts, experimentation, creative exploration, and internal team review.</li>
    <li>Unreviewed AI Images MAY NOT be used for advertising, marketing, social media, branding, packaging, websites, apps, editorial, print, OOH, broadcast, client presentations, agency pitches, WhatsApp/email sharing, or any public-facing use.</li>
    <li>Sharing an Unreviewed AI Image with ANY external party is prohibited public use.</li>
    <li>Unreviewed AI Images carry no warranties, no legal clearance, no indemnity, and no commercial rights.</li>
</ul>

<h6>2.2. Reviewed & Approved AI Images — Commercial License</h6>
<ul>
    <li>Approved AI Images may be used commercially after undergoing compliance review and receiving a Commercial AI License Certificate.</li>
    <li>Approved AI Images may be used in digital, print, broadcast, social media, OOH, and promotional materials.</li>
    <li>Rejected images remain internal-use only.</li>
</ul>

<h6>3. Non-Exclusivity & Non-Uniqueness</h6>
<ul>
    <li>AI outputs are not exclusive. IndiaPicture does not guarantee uniqueness, originality, or exclusivity.</li>
</ul>

<h6>4. Prohibited AI Uses</h6>
<ul>
    <li>Users may NOT create or use AI images involving: public figures; brands or trademarks; copyrighted characters or styles; regulated-industry claims (medical, financial, legal, real estate, nutrition); sensitive content (political, religiously offensive, explicit, minors, hate, violence, misleading content); synthetic humans resembling real persons; or copyrighted uploads.</li>
    <li>Prompt-based attempts to generate prohibited content are also violations.</li>
</ul>

<h6>5. Modification Restrictions</h6>
<ul>
    <li>Modifying AI images does not expand rights. Risky modifications void indemnity. Modified images may require new approval.</li>
</ul>

<h6>6. Sharing & Distribution Restrictions</h6>
<ul>
    <li>Users may NOT share unreviewed AI images externally, online, in client decks, or with vendors or freelancers.</li>
</ul>

<h6>7. AI Training Restrictions</h6>
<ul>
    <li>Users may NOT use IndiaPicture AI outputs to train or improve machine learning models.</li>
</ul>

<h6>8. Compliance Review Process</h6>
<ul>
    <li>Submission: User requests image review.</li>
    <li>Evaluation: IndiaPicture checks for resemblance, trademarks, copyright, sensitive content, and compliance.</li>
    <li>Outcomes: Approved → Certificate issued; Rejected → internal use only; Returned → modify and resubmit.</li>
    <li>Disclaimer: Approval is a reasonable compliance check, not a guarantee.</li>
</ul>

<h6>9. User Warranties</h6>
<ul>
    <li>Users warrant ownership of uploaded inputs, absence of copyright infringement, compliance with law, and indemnify IndiaPicture for violations.</li>
</ul>

<h6>10. Accuracy, Bias & Representation Disclaimer</h6>
<ul>
    <li>AI output may contain inaccuracies, distortions, or biases. User must verify suitability.</li>
</ul>

<h6>11. Indemnification for AI Images</h6>
<ul>
    <li>Only Approved AI Images qualify for indemnity.</li>
    <li>Indemnity cap: INR 50,000 per approved AI image.</li>
    <li>No indemnity for unreviewed images, prohibited uses, copyrighted uploads, modified images, or regulated misuse.</li>
</ul>

<h6>12. Limitations of Liability</h6>
<ul>
    <li>IndiaPicture is not liable for misuse, resemblance to real persons, inaccuracies, user uploads, or consequential damages.</li>
</ul>

<h6>13. Termination</h6>
<ul>
    <li>IndiaPicture may revoke licensing if the user violates prohibited uses, misuses unreviewed images, uploads protected content, bypasses review, or uses AI outputs to train models.</li>
</ul>
`;
